import normalizeText from './normalize-Text';

const extractAccordionTable = (html: any) => {
  let contentDiv = html;

  if (typeof (html) === 'string') {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    contentDiv = doc.querySelector('.accordion');
  }

  if (contentDiv instanceof Element) {
    const cells = contentDiv.querySelectorAll('td');
    return {
      title: cells[2].innerHTML || '',
      content: cells[3].innerHTML || '',
    };
  }

  return { title: '', content: '' };
};

export default extractAccordionTable;
